import { grey } from '@mui/material/colors'
import { darken, lighten } from '@mui/material/styles'

export const DEFAULT_TONAL_OFFSET = 0.2

// Colors palette and names come from: https://coolors.co/
export const COLORS = {
    white: '#FFFFFF',
    black: '#000000',
    theme: {
        primary: {
            light: '#e4f0da',
            main: '#7ee894',
            dark: '#28523A',
            darker: '#0b2617'
        },
        secondary: {
            light: grey[200],
            main: grey[500],
            dark: grey[700],
            darker: grey[800]
        },
        error_red: {
            main: '#f2545b',
            light: lighten('#f2545b', DEFAULT_TONAL_OFFSET),
            dark: darken('#f2545b', DEFAULT_TONAL_OFFSET)
        },
        warning_yellow: {
            main: '#F9C80E',
            light: lighten('#F9C80E', DEFAULT_TONAL_OFFSET),
            dark: darken('#F9C80E', DEFAULT_TONAL_OFFSET)
        },
        success_green: {
            main: '#419a44',
            light: lighten('#419a44ff', DEFAULT_TONAL_OFFSET),
            dark: darken('#419a44ff', DEFAULT_TONAL_OFFSET)
        }
    }
}
